import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetEmailQueueBlacklist } from 'domain/usecases';
import { RemoteGetEmailQueueBlacklist } from 'data/usecases';

export const makeRemoteGetEmailQueueBlacklist = (): GetEmailQueueBlacklist => {
  return new RemoteGetEmailQueueBlacklist(makeApiUrl('/queue/emails'), makeAuthorizeHttpClientDecorator());
};
